import React from 'react';
import {Row,Col} from 'react-bootstrap';
import cssClassses from './ConsoleTitle.css';
// import AudioAnalyser from '../../Visualisation/AudioAnalyser/AudioAnalyser';

const consoleTitle = (props) => {
    const artist = props.artist || 'Unknown Artist';
    const durationText = props.duration || "00:00";
    return (
        <Row className={cssClassses.FirstRow} style={props.styles.flex}>
            <Col className={cssClassses.LogoCol} md={2} xs={2} lg={2} sm={2}>
                <img src={props.logo} alt="logo 1"/>
            </Col>
            <Col className={cssClassses.SongInfoCol}>
                <Row style={props.styles.flex} className={cssClassses.SongInfoRow}>
                    <Col md={7} sm={7} className={props.styles.songName.className + " " + cssClassses.SongName}>{props.name}</Col>
                    <Col className={cssClassses.duration + " " +props.styles.songDuration.className}>{durationText}</Col>
                </Row>
                <Row>
                    <Col className={cssClassses.ArtistInfoRow + " " + props.styles.artistInfo.className}>{artist}</Col>
                </Row>
                {/* <Row>
                    <AudioAnalyser analyser={props.analyser} dataArray={props.dataArray}/>
                </Row> */}
            </Col>
        </Row>
    );

}

export default consoleTitle;